import React from "react";
import Input from "../../components/UI/Input/Input";
import classes from "./Controls.module.css";
import { useTranslation } from 'react-i18next';

const Controls = props => {
    // eslint-disable-next-line
    const [t, i18n] = useTranslation(["misc"]);

    return (
    <div className={classes.Wrapper}>
        <Input title={t("SEED")} changed={props.seedValidator} val={props.currentSeed} />
        <Input title={t("STARTFRAME")} val={props.currentStartFrame} changed={props.startValidator} />
        <Input title={t("NUMBEROFFRAMES")} val={props.currentNumberOfFrames} changed={props.numberValidator} />
        <div>
            <button className={classes.Button} onClick={props.calculateResults}>{t("DISPLAYRESULTS")}</button>
            <button className={classes.Button} onClick={props.filter}>{t("FILTERRESULTS")}</button>
            <button className={classes.Button} onClick={props.search}>{t("STARTSEARCH")}</button>
        </div>
    </div>);
}

export default React.memo(Controls);